import React from 'react'
import TanModal from '@/modules/banking/components/tan-modal/tan-modal'
import { CancelTanRequestError } from '@/modules/banking/errors'

import store from '@/redux/store'
import { UNSAFE_renderElement as renderElement } from '@/hooks/useGlobalPortal'

const openTanModal = ({ transaction, processId, onSuccess, onError, onAbort }) => {
  const { transactionId } = transaction
  return new Promise((resolve, reject) => {
    const getComponent = (close) => {
      return (
        <div data-transaction-id={transactionId}>
          <TanModal
            open={true}
            store={store}
            transaction={transaction}
            processId={processId}
            onSuccess={(data) => {
              onSuccess(data)
              close()
              resolve(data)
            }}
            onError={(error) => {
              onError(error)
              close()
              reject(error)
            }}
            onAbort={() => {
              onAbort()
              close()
              reject(new CancelTanRequestError(transaction))
            }}
          />
        </div>
      )
    }
    renderElement(getComponent)
  })

}

export default openTanModal
